// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sidbar mobile */
@media (orientation: landscape) and (max-width: 890px) {
    .sideContainerParent {
        position: fixed;
        height: 100%;
        width: 100%;
        overflow-y: auto;
    }

    .sideContainer {
        height: auto;
        min-height: 100%;
        padding-top: 10px;
        margin: 0;
        margin-left: -30px;
        padding-bottom: 20px;
    }

    .sideNavbarText {
        padding: 0px;
    }

    .sideNavbarText h3 {
        padding: 0.2em;
    }

    .sideNavbarImage {
        padding-bottom: 0.2em;
    }

    .notActiveSide:hover {
        text-align: center;
    }
}

@media only screen and (max-width: 890px) {
    .buttonContainerSidbar {
        position: fixed;
    }

    .sideNavbarText {
        padding: 0px;
    }

    .sideNavbarText h3 {
        padding: 0.8em;
    }

    .sideContainerParent {
        position: fixed;
        height: 100%;
        width: 100%;
    }

    .sideContainer {
        height: auto;
        min-height: 100vh;
        padding-top: 10px;
        margin: 0;
        margin-left: -30px;
    }

    .sideContainer h3 {
        font-size: 0.9em;
    }

    .notActiveSide:hover {
        text-align: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Menus/SideMenu/sideMenuMobile.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI;QACI,eAAe;QACf,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;QACT,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;QACjB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* sidbar mobile */\n@media (orientation: landscape) and (max-width: 890px) {\n    .sideContainerParent {\n        position: fixed;\n        height: 100%;\n        width: 100%;\n        overflow-y: auto;\n    }\n\n    .sideContainer {\n        height: auto;\n        min-height: 100%;\n        padding-top: 10px;\n        margin: 0;\n        margin-left: -30px;\n        padding-bottom: 20px;\n    }\n\n    .sideNavbarText {\n        padding: 0px;\n    }\n\n    .sideNavbarText h3 {\n        padding: 0.2em;\n    }\n\n    .sideNavbarImage {\n        padding-bottom: 0.2em;\n    }\n\n    .notActiveSide:hover {\n        text-align: center;\n    }\n}\n\n@media only screen and (max-width: 890px) {\n    .buttonContainerSidbar {\n        position: fixed;\n    }\n\n    .sideNavbarText {\n        padding: 0px;\n    }\n\n    .sideNavbarText h3 {\n        padding: 0.8em;\n    }\n\n    .sideContainerParent {\n        position: fixed;\n        height: 100%;\n        width: 100%;\n    }\n\n    .sideContainer {\n        height: auto;\n        min-height: 100vh;\n        padding-top: 10px;\n        margin: 0;\n        margin-left: -30px;\n    }\n\n    .sideContainer h3 {\n        font-size: 0.9em;\n    }\n\n    .notActiveSide:hover {\n        text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
